
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15","cy":"15","r":"14.5","fill":"#fff","stroke":"#41C8C3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.309 7.795c.62-1.505 2.761-1.505 3.382 0l.865 2.095c.1.242.35.387.611.352l2.255-.302c1.62-.217 2.69 1.628 1.692 2.916l-1.39 1.793a.573.573 0 000 .703l1.39 1.792c.998 1.288-.072 3.134-1.692 2.916l-2.255-.302a.578.578 0 00-.611.352l-.865 2.095c-.62 1.505-2.761 1.505-3.382 0l-.865-2.095a.578.578 0 00-.611-.352l-2.255.302c-1.62.218-2.69-1.628-1.692-2.916l1.39-1.792a.573.573 0 000-.704l-1.39-1.792c-.998-1.288.072-3.133 1.692-2.916l2.255.302c.26.035.511-.11.611-.352l.865-2.095zm2.225.473a.579.579 0 00-1.068 0l-.865 2.095a1.83 1.83 0 01-1.935 1.113l-2.255-.303a.575.575 0 00-.535.922l1.39 1.793c.509.655.509 1.569 0 2.224l-1.39 1.793a.575.575 0 00.535.922l2.255-.303a1.83 1.83 0 011.935 1.113l.865 2.095a.579.579 0 001.068 0l.865-2.095a1.83 1.83 0 011.935-1.113l2.255.303a.575.575 0 00.535-.922l-1.39-1.793a1.814 1.814 0 010-2.224l1.39-1.793a.575.575 0 00-.535-.922l-2.255.303a1.83 1.83 0 01-1.935-1.113l-.865-2.095zM15 13.491c-.837 0-1.515.676-1.515 1.509 0 .833.678 1.509 1.516 1.509.837 0 1.515-.676 1.515-1.509 0-.833-.678-1.509-1.515-1.509zM12.235 15a2.76 2.76 0 012.767-2.754A2.76 2.76 0 0117.767 15 2.76 2.76 0 0115 17.754 2.76 2.76 0 0112.234 15z","fill":"#41C8C3"}})])
          )
        }
      }
    